import styled from 'styled-components';
import { fontFamilySize, px } from '../../contrib/ui';

interface INewPlayerCardStyledProps {
  isDragging: boolean;
}

export const NewPlayerCardStyled = styled.div<INewPlayerCardStyledProps>`
  position: relative;

  .card-paper {
    background-color: ${({ isDragging }) => (isDragging ? '#60c6aa' : 'white')};
    box-shadow: 0px 0px 5px 5px rgb(0 0 0 / 5%);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    height: ${px(100)};
    padding: ${px(10)};
    padding-left: ${px(20)};
    width: 100%;
    position: relative;

    .img {
      width: ${px(80)};
      height: ${px(80)};
      margin-right: ${px(10)};

      img {
        width: ${px(80)};
        height: ${px(80)};
        border-radius: 50%;
      }
    }

    .player-card-info {
      .name {
        ${fontFamilySize('Heavy', 16)}
      }

      .index-tee {
        .index,
        .tee {
          ${fontFamilySize('Medium', 14)};
          display: inline;
        }
        .index {
          margin-right: ${px(25)};
          .label {
            margin-right: ${px(5)};
            color: var(--grey87);
          }
        }
      }
    }
    .top-left-corner-icon {
      position: absolute;
      top: ${px(2)};
      left: ${px(2)};
    }

    .top-right-corner-icon {
      position: absolute;
      top: ${px(10)};
      right: ${px(10)};
    }

    .bottom-right-corner-icon {
      position: absolute;
      bottom: ${px(10)};
      right: ${px(10)};
    }

    .comment-icon {
      transform: scale(-1, 1);
    }

    .corner-arrow {
      transform: rotate(90deg);
      color: var(--greydd);

      &:hover {
        color: var(--mainColor);
        cursor: pointer;
      }
    }

    .remove-player-icon,
    .swap-player-icon {
      color: var(--greydd);

      &:hover {
        color: var(--mainColor);
        cursor: pointer;
      }
    }

    .right-arrow {
      cursor: pointer;
      position: absolute;
      font-size: ${px(40)};
      height: ${px(40)};
      right: 0;
      top: calc(50% - ${px(20)});
    }
  }
`;
